import React from 'react'
import { Card, Input } from 'antd';

const W4FormStep4 = (props) => {
  const { w4Form, setW4Form, disableAll } = props;

  const handleChange = (e) => {
    const { name, value } = e.target
    let new_value = (value ?? '') == '' ? 0 : parseInt(value);
    if (parseInt(new_value) < 0) {
      new_value = parseInt(new_value) * -1; //convert positive to negative
    }

    if (name == 'otherIncome') {
      setW4Form({
        ...w4Form, ...{
          otherIncome: new_value,
        }
      })
    }
    else if (name == 'deductions') {
      setW4Form({
        ...w4Form, ...{
          deductions: new_value,
        }
      })
    }
    else if (name == 'extraWithholding') {
      setW4Form({
        ...w4Form, ...{
          extraWithholding: new_value,
        }
      })
    }
  }

  const handleKeyUp = (e) => {
    const { keyCode } = e
    const { name } = e.target
    if (keyCode == 189) {
      if (name == 'otherIncome') {
        setW4Form({
          ...w4Form, ...{
            otherIncome: 0,
          }
        })
      }
      else if (name == 'deductions') {
        setW4Form({
          ...w4Form, ...{
            deductions: 0,
          }
        })
      }
      else if (name == 'extraWithholding') {
        setW4Form({
          ...w4Form, ...{
            extraWithholding: 0,
          }
        })
      }
    }
  }

  return (
    <Card type="inner" title={'Step 4. Other Adjustments'}>
      <p>Other income (not from jobs). If you want tax withheld for other income you expect this year that wont have withholding, enter the amount of other income here. This may include interest, dividends, and retirement income. You should not include income from any jobs.
        <Input prefix="$" style={{ width: '6em' }}
          type='number'
          min="0"
          disabled={disableAll}
          name='otherIncome'
          value={w4Form.otherIncome}
          onChange={e => handleChange(e)}
          onKeyUp={handleKeyUp}
        />
      </p>
      <p>Deductions. If you expect to claim deductions other than the standard deduction and want to reduce your withholding, use the Deductions Worksheet.
        <Input prefix="$" style={{ width: '6em' }}
          type='number'
          min="0"
          disabled={disableAll}
          name='deductions'
          value={w4Form.deductions}
          onChange={e => handleChange(e)}
          onKeyUp={handleKeyUp}
        />
      </p>
      <p>Extra withholding. Enter any additional tax you want withheld each pay period.
        <Input prefix="$" style={{ width: '6em' }}
          type='number'
          min="0"
          disabled={disableAll}
          name='extraWithholding'
          value={w4Form.extraWithholding}
          onChange={e => handleChange(e)}
          onKeyUp={handleKeyUp}
        />
      </p>
    </Card>
  )
}
export default W4FormStep4
